import fetchAxios from "services/http";

export const deleteChecking = async (checkinId: number) => {
    try {
        await fetchAxios.delete(`/checkin/delete/${checkinId}`)
    } catch (error) {
        console.error('Erro ao deletar o checkin:', error);
    }
}